<template>
    <b-card no-body class="overflow-hidden">
        <b-row>
            <b-col class="m-2">
                <div class="user-img">
                    <b-img
                        rounded 
                        src="https://eitrawmaterials.eu/wp-content/uploads/2016/09/person-icon.png" 
                        width="60" 
                        height="60"
                        
                    />
                </div>
                <div class="user-details">
                    <div>
                        <b-link class="text-success font-weight-bold">Catsi C.</b-link>
                    </div>
                    <div>
                        Added 2 photos
                    </div>
                </div>
            </b-col>
        </b-row>
        <b-row class="m-2 text-success font-weight-bold">
            <b-col>
                Tori Tori Kushiyaki Snack Bar
            </b-col>
        </b-row>
        <b-row no-gutters>
            <b-col>
                <RecentActivityCardPhotoSnippet class="m-2" />
            </b-col>
            <b-col>
                <RecentActivityCardPhotoSnippet class="m-2" />
            </b-col>
        </b-row>
    </b-card>
</template>

<style scoped>
.image1 {
    width: 100%;
    height: 220px;
    object-fit: cover;
}

.user-img {
    position: relative;
    display: block;
    float: left;
}

.user-details {
    margin-left: 70px;
}

.separator {
    margin-top: 10px; 
    margin-bottom: 0px
}
</style>

<script>
import RecentActivityCardPhotoSnippet from './RecentActivityCardPhotoSnippet'

export default {
    components: {
        RecentActivityCardPhotoSnippet
    }
}
</script>